import React from 'react'
import PropTypes from 'prop-types'

import googleButtonEn from 'components/images/google/en_add_to_google_wallet.svg'
import googleButtonDe from 'components/images/google/de_add_to_google_wallet.svg'
import googleButtonFr from 'components/images/google/fr_add_to_google_wallet.svg'
import googleButtonNb from 'components/images/google/nb_add_to_google_wallet.svg'

const GoogleButton = ({ token, t, locale, action }) => {
  const lang = locale.substr(0, 2)

  const walletButtons = {
    en: googleButtonEn,
    de: googleButtonDe,
    fr: googleButtonFr,
    nb: googleButtonNb,
  }

  const googleButtonImg = walletButtons[lang] ?? walletButtons.en

  return (
    <React.Fragment>
      <a href={token.pass.link_url} onClick={action}>
        <img src={googleButtonImg} alt={t('pages.membership.access.nfc.add_to_wallet.google')}
          style={{ border: 'none', marginLeft: 'auto', marginRight: 'auto', display: 'block' }}
          className='google add'
        />
      </a>
    </React.Fragment>
  )
}

GoogleButton.propTypes = {
  token: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
  action: PropTypes.func.isRequired,
}

export default GoogleButton
